import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFiles } from '../../store/entities/selectors';
import PlaylistItem from '../PlaylistItem';
import { IFile } from '../../services/api/requests/getAudioList';
import { selectLoading } from '../../store/system/selectors';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { deviceMaxWidth } from '../../constants';
import { playAudioTrack } from '../../store/entities/actions';
import PlaylistPagination from '../PlaylistPagination';

export default function Playlist() {
  const styles = useStyles();
  const files = useSelector(selectFiles);
  const loading = useSelector(selectLoading);
  const isFiles = !!files.length;
  const dispatch = useDispatch();

  const playAudioTrackHandler = (id: number) => dispatch(playAudioTrack(id));

  const renderLoader = () => (
    // TODO: change loader to skeleton
    <div className={styles.boxContainer}>
      <CircularProgress color="primary" />
    </div>
  );

  const renderList = () => (
    <div className={styles.playlist}>
      {files?.map((file: IFile) => (
        <PlaylistItem
          key={file.file_md5}
          {...file}
          onClick={playAudioTrackHandler}
        />
      ))}
    </div>
  );

  return (
    <div className={styles.listItemContainer}>
      {isFiles ? (
        <>
          {loading ? renderLoader() : renderList()}
          <PlaylistPagination />
        </>
      ) : (
        <div className={styles.nothing}>Nothing here ¯\_(ツ)_/¯</div>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  listItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    [deviceMaxWidth.size768]: {
      marginBottom: 20,
    },
  },
  playlist: {
    minHeight: 500,
  },
  boxContainer: {
    minHeight: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  nothing: {
    minHeight: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
